(function () {
  'use strict';

  var config = window.colorSwatchConfig;
  if (!config) return;

  var container = document.getElementById('swatch-links');
  if (!container) return;

  var SECTION_SELECTOR = '.js-product-section';
  var cachedProducts = null;

  // --- Fetch product list for this color group ---

  function fetchProducts() {
    if (cachedProducts) return Promise.resolve(cachedProducts);

    var collectionUrl = '/collections/' + config.collectionHandle + '?view=swatch';

    return fetch(collectionUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Collection fetch failed');
        return res.json();
      })
      .catch(function () {
        // Fallback: search API
        var searchUrl = '/search?view=products-endpoint&type=product&q=tag:"' + config.groupTag + '"';
        return fetch(searchUrl).then(function (res) { return res.json(); });
      })
      .then(function (products) {
        cachedProducts = products;
        return products;
      });
  }

  // --- Parse swatch color from product tags ---

  function getSwatchStyle(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('swatch:') === 0) {
        var value = tags[i].substring(7);

        // Gradient: two hex colors separated by underscore
        if (value.indexOf('_') !== -1 && value.indexOf('#') !== -1) {
          var parts = value.split('_');
          return 'linear-gradient(to right, ' + parts[0] + ' 0%, ' + parts[0] + ' 50%, ' + parts[1] + ' 50%, ' + parts[1] + ' 100%)';
        }

        // Image URL
        if (value.indexOf('http') !== -1) {
          return "url('" + value + "')";
        }

        // Solid color
        return value;
      }
    }
    return null;
  }

  // --- Render swatches ---

  function renderSwatches(products) {
    container.innerHTML = '';

    products.forEach(function (product) {
      var swatchStyle = getSwatchStyle(product.tags);
      if (!swatchStyle) return;

      var btn = document.createElement('button');
      btn.className = 'color-swatches__item';
      btn.style.background = swatchStyle;
      btn.setAttribute('aria-label', product.title);
      btn.setAttribute('data-url', product.url.split('?')[0]);
      btn.setAttribute('data-handle', product.handle);
      btn.setAttribute('data-variant-id', product.variants[0].id);

      if (product.handle === config.currentHandle) {
        btn.classList.add('active');
      }
      if (!product.available) {
        btn.classList.add('sold-out');
      }

      btn.addEventListener('click', onSwatchClick);
      container.appendChild(btn);
    });
  }

  // --- Handle swatch click ---

  function onSwatchClick(e) {
    var btn = e.currentTarget;
    var url = btn.getAttribute('data-url');
    var variantId = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-handle');

    if (handle === config.currentHandle) return;
    if (btn.classList.contains('sold-out')) return;

    // Visual feedback
    container.querySelectorAll('.color-swatches__item').forEach(function (el) {
      el.classList.remove('active');
    });
    btn.classList.add('active');
    document.body.classList.add('is-loading');

    // Update URL without reload
    window.history.replaceState('', '', url + '?variant=' + variantId);
    config.currentHandle = handle;

    // Fetch new product section via Section Rendering API
    // In JSON templates the section ID is dynamic (e.g. template--12345--main),
    // so we use the sectionId passed from Liquid rather than hardcoding.
    var sectionUrl = url + '?section_id=' + encodeURIComponent(config.sectionId);

    fetch(sectionUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed');
        return res.text();
      })
      .then(function (html) {
        var currentSection = document.querySelector(SECTION_SELECTOR);
        if (!currentSection) return;

        // Parse the returned HTML
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector(SECTION_SELECTOR);

        if (newSection) {
          currentSection.parentNode.replaceChild(newSection, currentSection);

          // Re-initialize Turbo theme product page JS.
          // runOptionSelector wires up OptionSelectors → onVariantSelected, which is
          // what appends the "You Save X%" .savings span to the price UI. Without
          // it, the savings text disappears after a swatch click.
          if (window.productPage) {
            if (window.productPage.init) window.productPage.init();
            if (window.productPage.runOptionSelector) window.productPage.runOptionSelector();
            if (window.productPage.initializeQuantityBox) window.productPage.initializeQuantityBox();
          }

          // Re-render swatches in the new DOM (the container was replaced)
          reinitSwatches();

          // Re-initialize product add-ons
          if (window.initProductAddons) window.initProductAddons();
        }
      })
      .catch(function (err) {
        console.error('Color swatch navigation failed:', err);
        // Fallback: regular navigation
        window.location.href = url + '?variant=' + variantId;
      })
      .finally(function () {
        document.body.classList.remove('is-loading');
      });
  }

  // --- Re-initialize after DOM replacement ---
  // The new section HTML includes a fresh #swatch-links container but
  // the inline <script> setting colorSwatchConfig won't re-execute.
  // We keep our cached config/products and just re-render into the new container.

  function reinitSwatches() {
    container = document.getElementById('swatch-links');
    if (!container) {
      // The new product might not have a group tag — nothing to render
      return;
    }

    if (cachedProducts) {
      renderSwatches(cachedProducts);
    } else {
      init();
    }
  }

  // --- Init ---

  function init() {
    fetchProducts()
      .then(function (products) {
        if (products && products.length > 1) {
          renderSwatches(products);
        }
      })
      .catch(function (err) {
        console.error('Color swatches failed to load:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
